module.exports = __webpack_public_path__ + "static/img/binocle.944aa6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/binocle.png
// module id = iIY3
// module chunks = 1